/* eslint-disable complexity */
import React from 'react';
import headingSchema from '../../../lib/composer/schemas/heading';
import subheadingSchema from '../../../lib/composer/schemas/subheading';
import { appLinkImagesSchema } from '../../../lib/composer/schemas/images';
import { Box, Flex } from '@osmosis/tailwind-ui/components/Box';
import Subheading from '../block-ui/Subheading';
import Heading from '../block-ui/Heading';
import { AppStoreLinksBlockProps } from '../../../types/composer';
import BlockWrapper from '../BlockWrapper';
import type { AppLinkImageItem } from '../../../types/composer';
import Image from 'next/image';
import Link from 'next/link';
import RichText from '../block-ui/RichText';

type AppLinkImageItemProps = {
  image: AppLinkImageItem;
  text?: string;
};

/**
 * App store link image.
 */
const AppLinkImageItem = ({ image, text }: AppLinkImageItemProps) => {
  return (
    <Flex
      data-testid="app-link-wrapper"
      className="flex flex-col text-center items-center gap-4"
    >
      <Link className="p-3" href={image.url ?? ''}>
        <Image
          src={image.image ?? ''}
          alt={image.altText ?? ''}
          width="150"
          height="150"
        />
      </Link>

      {text && (
        <RichText
          alignment={'center'}
          html={text}
          containerProps={{ fontSize: '20px' }}
        />
      )}
    </Flex>
  );
};

/**
 * App store links block.
 */
const AppStoreLinks: any = (props: AppStoreLinksBlockProps) => {
  const { heading, subheading, images = [], topHeader } = props;

  return (
    <Box className="bg-white">
      <BlockWrapper>
        <Box className="p-3 max-w-[1000px] mx-auto">
          <Flex className="flex-1 flex flex-col items-center gap-3">
            {!!heading && <Heading text={heading} topHeader={topHeader} />}
            {!!subheading && (
              <Subheading text={subheading} topHeader={topHeader} />
            )}

            <Flex
              className="justify-center flex-wrap gap-10"
              data-testid="links-container"
            >
              {!!images?.length &&
                images.map((img, i) => {
                  return (
                    <AppLinkImageItem
                      key={img.image}
                      image={img}
                      text={img.text}
                    />
                  );
                })}
            </Flex>
          </Flex>
        </Box>
      </BlockWrapper>
    </Box>
  );
};

AppStoreLinks.schema = {
  name: 'app-store-links',
  label: 'App Store Links',
  editableProps: [headingSchema, subheadingSchema, appLinkImagesSchema],
};

export default AppStoreLinks;
